'use client';

import { useState, ChangeEvent, KeyboardEvent } from 'react';
import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $aiChat, updateAIChatEvent } from '@nx-frontend/shared/store/transcript-panel';

export function TranscriptAiInput() {
  const [inputValue, setInputValue] = useState<string>('');
  const [aiChat, updateAIChat] = useUnit([$aiChat, updateAIChatEvent]);
  const t = useTranslations('features');

  const sendRequest = () => {
    if (inputValue) {
      if ('done' === aiChat.state) {
        updateAIChat({
          prompt: inputValue,
        });
        setInputValue('');
      }
    }
  };

  const cancelRequest = () => {
    updateAIChat({
      canceled: true,
    });
  };

  const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      sendRequest();
    }
  };

  return (
    <div className="flex bg-white flex-col items-center mt-[16px] w-[417px] h-[146px] p-[24px_24px_16px_24px] gap-[32px] flex-shrink-0 rounded-[8px] border border-[#E5E5E5]">
      <div className="w-full h-full">
        <textarea
          className="textarea resize-none input-edit-class w-full h-[50px] text-[13px] !outline-none !border-none placeholder:text-[13px]"
          placeholder={t('transcript.ask_ai_to_edit')}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          value={inputValue}
        />
        <div className="mt-[6px] pt-[12px] border-t border-[#E5E5E5] border-t-[1px] h-[40px]">
          <div className="flex flex-row justify-between">
            <div></div>
            <div>
              {'done' === aiChat.state ? (
                <button
                  className="flex items-center justify-center whitespace-nowrap select-none h-[28px] px-2 bg-cyan-900 hover:bg-cyan-700 active:bg-cyan-700 text-white rounded-md"
                  onClick={sendRequest}
                >
                  <Icon icon={IconsMap.MAGIC_1} className="w-[12px] h-[12px] text-white" />
                  <span className="ml-[3px] text-[13px]">{t('transcript.send')}</span>
                </button>
              ) : (
                <button
                  className="flex items-center justify-center whitespace-nowrap select-none h-[28px] px-2 bg-cyan-900 hover:bg-cyan-700 active:bg-cyan-700 text-white rounded-md"
                  onClick={cancelRequest}
                >
                  <Icon icon={IconsMap.PAUSE} className="w-[12px] h-[12px] text-white" />
                  <span className="ml-[3px] text-[13px]">{t('transcript.stop_generate')}</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
